export enum XIDR_VERIFICATION_ACTIONS {
  SET_PERSONAL_DETAIL = 'XIDR_VERIFICATION_ACTIONS.SET_PERSONAL_DETAIL',
  UPDATE_PERSONAL_DETAIL = 'XIDR_VERIFICATION_ACTIONS.UPDATE_PERSONAL_DETAIL',
  SET_DOCUMENT_UPLOAD_URLS = 'XIDR_VERIFICATION_ACTIONS.SET_DOCUMENT_UPLOAD_URLS',
  SET_UPLOAD_KTP_PHOTO_LIST = 'XIDR_VERIFICATION_ACTIONS.SET_UPLOAD_KTP_PHOTO_LIST',
  SET_UPLOAD_SELFIE_PHOTO_LIST = 'XIDR_VERIFICATION_ACTIONS.SET_UPLOAD_SELFIE_PHOTO_LIST',
  SET_LIVE_SELFIE_PHOTO = 'XIDR_VERIFICATION_ACTIONS.SET_LIVE_SELFIE_PHOTO',
}
